import { z } from 'zod';
import { zIntegrationProperties, zIntegrationPropertyValue, } from '../core';
export const zIntegrationPropertiesFormSchema = z.array(z
    .object({
    provider: z.string().min(1),
    property: z.string().min(1),
    value: zIntegrationPropertyValue,
})
    .refine(({ provider, property, value }) => {
    return zIntegrationProperties.safeParse({
        [provider]: { [property]: value },
    }).success;
}, 'Invalid property or value for provider'));
export const ProviderMap = {
    eliteform: 'Elite Form',
};
export const PropertyMap = {
    trackerClassification: 'Tracker Classification',
};
//# sourceMappingURL=integration-providers.js.map